import BasketIcon from "theme/components/icons/BasketIcon";
import Cookies from "js-cookie";
import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import ThemeButton from "theme/components/buttons/ThemeButton";
import getBasket from "core-web/state/models/Basket/dispatches/getBasket";
import { getState } from "core-web/state";
import hideOverlays from "core-web/state/models/Overlay/dispatches/hideOverlays";
import hidePopup from "core-web/state/models/Popups/dispatches/hidePopup";
import showOverlay from "core-web/state/models/Overlay/dispatches/showOverlay";
import styled from "theme/libs/styled";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const BasketCount = styled("div")`
    position: absolute;
    top: 0;
    right: -50%;
    padding: 3px 3px 2px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.blue_100};
    min-width: 18px;
    min-height: 18px;
`;

const BasketButton = ({ handleBasketClick, isMobile, ...rest }) => {
    const { t } = useTranslation();

    const { searchIsOpen } = useSelector(({ header }) => header.states);
    const basketIsOpen = getState("overlay").current === "basket_overlay";

    const { isFetched, isFetching, items } =
        useSelector(
            ({ basket }) => basket,
            (prev, next) =>
                prev.basket?.isFetched !== next.basket?.isFetched ||
                prev.basket?.isFetching !== next.basket?.isFetching ||
                prev?.basket?.items !== next?.basket?.items,
        ) || {};

    const basketItemsCount =
        (isFetched
            ? items.map((items) => items?.quantity).reduce((a, b) => a + b, 0)
            : parseInt(Cookies.get("basket_items_amount"), 10)) || 0;

    const openBasket = () => {
        handleBasketClick();
        hidePopup("addedToBasketPopup");

        if (basketIsOpen) {
            hideOverlays();
        } else {
            if (!isFetched && !isFetching) {
                getBasket();

                setTimeout(() => {
                    showOverlay("basket_overlay", {
                        searchOpen: searchIsOpen || !isMobile,
                    });
                }, 200);
            } else {
                showOverlay("basket_overlay", { searchOpen: searchIsOpen || !isMobile });
            }
        }
    };

    return (
        <ThemeButton
            disableHover
            onClick={openBasket}
            buttonTheme="transparent"
            aria-label={basketIsOpen ? t("aria_labels.close_basket") : t("aria_labels.open_basket")}
            position="relative"
            p={["12px", null, null, null, "10px"]}
            {...rest}
        >
            <BasketIcon width="20px" height="20px" />

            {basketItemsCount > 0 && (
                <BasketCount>
                    <TextStyles textStyles="Myriad Pro/12-100-semibold">{basketItemsCount}</TextStyles>
                </BasketCount>
            )}
        </ThemeButton>
    );
};

BasketButton.propTypes = {
    isMobile: PropTypes.bool,
    handleBasketClick: PropTypes.func,
    searchOpen: PropTypes.bool,
};

BasketButton.defaultProps = {
    isMobile: false,
    handleBasketClick: () => {},
    searchOpen: false,
};

export default BasketButton;
